import DocContainer from './DocContainer';

export default DocContainer;
